import * as React from "react";
import { DeleteOutline } from '@mui/icons-material';
import { Box, Button, Card, Container, Stack, Typography } from '@mui/material';
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DeleteModel from '../../components/Deletemodle';
import TableStyle from '../../components/TableStyle';
import { apiput, apidelete, deleteManyApi } from '../../service/api';
import { fetchSystemErrorData } from '../../redux/slice/systemErrorSlice';


function CustomToolbar({ selectedRowIds, fetchSystemErrorData }, userRole) {
    const [opendelete, setOpendelete] = useState(false);
    const [userAction, setUserAction] = useState(null);
    const dispatch = useDispatch()
    const handleCloseDelete = () => setOpendelete(false)
    const handleOpenDelete = () => setOpendelete(true)

    const deleteManyErrors = async (data) => {
        const result = await deleteManyApi('api/errors/deletemany', data)
        dispatch(fetchSystemErrorData())
        setUserAction(result)
        handleCloseDelete();
    }

    useEffect(() => {
        setUserAction(userAction)
    }, [userAction])

    return (
        <GridToolbarContainer>
            <Box padding={"10px 0"}>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector
                    slotProps={{ tooltip: { title: 'Change density' } }}
                />
            </Box>
            {userRole !== "user" && (selectedRowIds && selectedRowIds.length > 0 && <Button variant="text" sx={{ textTransform: 'capitalize' }} startIcon={<DeleteOutline />} onClick={handleOpenDelete}>Delete</Button>)}
            <DeleteModel opendelete={opendelete} handleClosedelete={handleCloseDelete} deletedata={deleteManyErrors} id={selectedRowIds} />
        </GridToolbarContainer>
    );
}

const SystemErrors = () => {

    const [selectedRowIds, setSelectedRowIds] = useState([]);

    const [userAction, setUserAction] = useState(null);
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { data, isLoading } = useSelector((state) => state?.systemErrorDetails)
    const userid = sessionStorage.getItem('user_id');
    const userRole = sessionStorage.getItem("userRole")

    const columns = [
        {
            field: "source",
            headerName: "Source",
            width: 250,
            cellClassName: "name-column--cell--capitalize",
            renderCell: (params) => {
                const handleClick = () => {
                    navigate(`/dashboard/systemerrors/view/${params.row._id}`);
                }
                return (
                    <Box onClick={handleClick} sx={{ cursor: 'pointer' }}>
                        {params.value}
                    </Box>
                );
            }
        },
        {
            field: "message",
            headerName: "Message",
            width: 400,
        },
        {
            field: "status",
            headerName: "Status",
            width: 150,
        },
        {
            field: "resolved",
            headerName: "Resolved",
            width: 150,
            renderCell: (params) => {
                return (
                    <Box sx={{ backgroundColor: params.value === true ? 'green' : 'red', fontWeight: 'bold', color: 'white', padding: '5px 10px', borderRadius: '5px', textAlign: 'center' }}>
                        {params.value === true ? "Yes" : "No"}
                    </Box>
                );
            }
        },
        {
            field: "createdOn",
            headerName: "Created On",
            width: 250,
            valueFormatter: (params) => {
                const date = new Date(params.value);
                return date.toLocaleString();
            }
        },
        {
            field: "action",
            headerName: "Action",
            width: 400,
            sortable: false,
            renderCell: (params) => {
                const handleResolveClick = async (id) => {
                    const result = await apiput('api/errors/resolve/'+ id)
                    dispatch(fetchSystemErrorData())
                    setUserAction(result)
                };
                const handleDeleteClick = async (id) => {
                    const result = await apidelete('api/errors/delete/'+ id)
                    dispatch(fetchSystemErrorData())
                    setUserAction(result)
                }
                return (
                    <>
                        { params?.row?.resolved !== true && (
                            <Button variant='text' size='small' color='primary' onClick={() => handleResolveClick(params?.row?._id)}>Resolve</Button>
                        )}
                        <Button variant='text' size='small' color='error' onClick={() => handleDeleteClick(params?.row?._id)}><DeleteOutline /></Button>
                    </>
                );
            }
        },
    ];

    const handleSelectionChange = (selectionModel) => {
        setSelectedRowIds(selectionModel);
    };
    useEffect(() => {
        dispatch(fetchSystemErrorData())
    }, [userAction])

    return (
        <div>
            <Container maxWidth>
                <TableStyle>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4">
                            System Errors
                        </Typography>
                    </Stack>
                    <Box width="100%">
                        {isLoading ? (
                            <Card style={{ display: 'flex', justifyContent: 'center', height: "600px" }}>
                                <span className="loader" />
                            </Card>
                        ) : (
                            <Card style={{ height: "600px" }}>
                                <DataGrid
                                    rows={data || []}
                                    columns={columns}
                                    components={{ Toolbar: () => CustomToolbar({ selectedRowIds, fetchSystemErrorData }, userRole) }}
                                    checkboxSelection
                                    onRowSelectionModelChange={handleSelectionChange}
                                    rowSelectionModel={selectedRowIds}
                                    getRowId={row => row._id}
                                />
                            </Card>
                        )}

                    </Box>
                </TableStyle>
            </Container>
        </div>
    )
}

export default SystemErrors
